let frontChatId: string;

function init(newId: string) {
    frontChatId = newId;
}

declare global {
    interface Window {
        FrontChat: any;
    }
}

const waitFor = (check: () => boolean, limit = 10, name = 'waitFor') =>
    new Promise((resolve, reject) => {
        let count = 0;

        const run = () => {
            if (check()) {
                resolve('OK');
            } else if (count > limit) {
                reject(`${name}: call limit reached`);
            } else {
                count = count + 1;
                setTimeout(() => run(), 100);
            }
        };
        run();
    });

export const frontChat = (...a: any[]) => {
    waitFor(() => !!window.FrontChat, 50, 'wait for FrontChat loaded').then(() => {
        window.FrontChat && window.FrontChat(...a);
    });
};

type BootData = {
    hide_default_launcher: boolean;
    userData?: {};
};

const boot = async (data = {} as BootData) => {
    if (!frontChatId) throw new Error('FrontChat: no id provided');

    const { hide_default_launcher, userData } = data;

    frontChat('init', {
        chatId: frontChatId,
        useDefaultLauncher: !hide_default_launcher,
        ...userData
    });
};

function setUser(user: anm.User) {
    const {
        username,
        email,
        userId,
        avatar,
        meta: { frontStudioHash },
        subscriptionDetails
    } = user;

    if (username && email && userId && avatar) {
        boot({
            hide_default_launcher: false,
            userData: {
                name: username,
                userHash: frontStudioHash,
                userId: userId,
                contact: {
                    email: email,
                    customFields: {
                        Admin: `https://webadmin.animatron${
                            options.isProduction ? '' : '-test'
                        }.com/admin/user.html?userId=${userId}`,
                        'Studio Plan': subscriptionDetails.studio.name,
                        'Wave Plan': subscriptionDetails.wave.name
                    }
                }
            }
        });
    }
}

function setAnonymous() {
    frontChat('shutdown');
    boot();
}

function show() {
    frontChat('show');
}

function hide() {
    frontChat('hide');
}

function unreadCountChange(cb: (n: number) => void) {
    frontChat('onUnreadChange', cb);
}

export default {
    init,
    boot,
    setUser,
    setAnonymous,
    show,
    hide,
    unreadCountChange
};



// WEBPACK FOOTER //
// ./app/assets/javascripts/frontChat.ts